import { render, staticRenderFns } from "./form-input1.vue?vue&type=template&id=8fcfa7e4&scoped=true&"
import script from "./form-input1.vue?vue&type=script&lang=js&"
export * from "./form-input1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcfa7e4",
  null
  
)

export default component.exports